import TextArea from 'antd/es/input/TextArea';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { DictionarySettingsValueModel } from 'stores/models/fieldsSettings';

type Props = {
  entity: DictionarySettingsValueModel;
};

const LABEL_CONFIG = { minRows: 1, maxRows: 3 };

const Label: React.FC<Props> = ({ entity }) => {
  const { t } = useTranslation();

  const onChange = React.useCallback(
    (event) => entity.setLabel(event.target.value),
    [entity]
  );

  return (
    <TextArea
      placeholder={t('common.enterName')}
      value={entity.label}
      autoSize={LABEL_CONFIG}
      onChange={onChange}
    />
  );
};

export default observer(Label);
